/* td-bundle — "Buy more, save more". Exibe preco com desconto (calculado) e
   adiciona N pecas por /cart/add.js. Nao cria desconto: o checkout aplica o
   desconto automatico por quantidade. */
(function () {
  'use strict';
  if (customElements.get('td-bundle')) return;

  function group(int, sep) { return int.replace(/(\d)(?=(\d\d\d)+$)/g, '$1' + sep); }

  function fromTemplate(cents, tpl) {
    var v = Number(cents) || 0;
    return tpl.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_m, t) {
      var p = (v / 100).toFixed(2).split('.');
      var r = String(Math.round(v / 100));
      switch (t) {
        case 'amount': return group(p[0], ',') + '.' + p[1];
        case 'amount_no_decimals': return group(r, ',');
        case 'amount_with_comma_separator': return group(p[0], '.') + ',' + p[1];
        case 'amount_no_decimals_with_comma_separator': return group(r, '.');
        case 'amount_with_space_separator': return group(p[0], ' ') + ',' + p[1];
        case 'amount_no_decimals_with_space_separator': return group(r, ' ');
        case 'amount_with_apostrophe_separator': return group(p[0], "'") + '.' + p[1];
        default: return group(p[0], ',') + '.' + p[1];
      }
    });
  }

  /* Se o molde do tema nao reproduz o preco que o servidor renderizou (moeda de
     apresentacao diferente da da loja), usa o proprio texto do servidor como
     molde: troca so a parte numerica e mantem simbolo/separadores. */
  function makeFormatter(el) {
    var tpl = el.dataset.moneyFormat || '';
    var sampleCents = Number(el.dataset.sampleCents);
    var sampleText = (el.dataset.sampleText || '').replace(/\s+/g, ' ').trim();
    if (tpl && sampleText && fromTemplate(sampleCents, tpl).replace(/\s+/g, ' ').trim() === sampleText) {
      return function (c) { return fromTemplate(c, tpl); };
    }
    var m = sampleText.match(/\d[\d.,'   ]*\d|\d/);
    if (!m) return function (c) { return fromTemplate(c, tpl || '${{amount}}'); };
    var num = m[0];
    var dec = num.match(/[.,](\d{1,2})$/);
    var decSep = dec ? num.charAt(num.length - dec[0].length) : '';
    var groupSep = (num.match(/[.,'   ]/g) || []).filter(function (c) { return c !== decSep; })[0] || '';
    var decimals = dec ? dec[1].length : 0;
    var pre = sampleText.slice(0, m.index), post = sampleText.slice(m.index + num.length);
    return function (c) {
      var parts = (Number(c) / 100).toFixed(decimals).split('.');
      return pre + (groupSep ? group(parts[0], groupSep) : parts[0]) + (decimals ? decSep + parts[1] : '') + post;
    };
  }

  function h(tag, attrs, kids) {
    var e = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      if (k === 'class') e.className = attrs[k];
      else if (k === 'text') e.textContent = attrs[k];
      else if (attrs[k] === true) e.setAttribute(k, '');
      else if (attrs[k] !== false && attrs[k] != null) e.setAttribute(k, attrs[k]);
    });
    (kids || []).forEach(function (c) { if (c) e.appendChild(c); });
    return e;
  }

  /* texto curto de preco: tira o codigo da moeda no fim ("R$ 298,00 BRL" -> "R$ 298,00") nos cards */
  function shortMoney(s) { return String(s).replace(/\s*[A-Z]{3}$/, '').replace(/\s+/g, '\u00a0'); }

  var uid = 0;

  customElements.define('td-bundle', class TdBundle extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      var cfg;
      try { cfg = JSON.parse(this.querySelector('[data-config]').textContent); } catch (e) { return; }
      this.cfg = cfg;
      this.fmt = makeFormatter(this);
      this.uid = ++uid;
      this.mount = this.querySelector('[data-mount]');
      this.msg = this.querySelector('[data-msg]');
      this.atc = this.querySelector('[data-atc]');
      this.single = cfg.variants.length === 1 || cfg.options.every(function (o) { return o.values.length === 1; });
      this.pct = { 1: 0, 2: Number(this.dataset.pct2) || 0, 3: Number(this.dataset.pct3) || 0 };
      this.plan = Number(this.dataset.popular === 'trio' ? 3 : this.dataset.popular === 'single' ? 1 : 2);
      /* escolhas por peca: lista de valores por opcao; cor pre-selecionada, tamanho nao. */
      this.sel = [0, 1, 2].map(function () {
        return cfg.options.map(function (o) { return o.values.length === 1 ? o.values[0].v : null; });
      });
      this.preselect();
      this.build();
      this.atc.addEventListener('click', this.add.bind(this));
      this.refresh();
    }

    sizeIndex() {
      var idx = this.cfg.options.findIndex(function (o) { return /^(size|tamanho|taille|talla|gr[oö](ss|ß)e)/i.test(o.name); });
      return idx;
    }

    preselect() {
      var self = this, si = this.sizeIndex();
      this.sel.forEach(function (s) {
        self.cfg.options.forEach(function (o, k) {
          if (s[k] !== null || k === si) return;
          /* primeira opcao nao-tamanho: o primeiro valor com alguma variante disponivel */
          for (var i = 0; i < o.values.length; i++) {
            if (self.cfg.variants.some(function (v) { return v.a && v.o[k] === o.values[i].v; })) { s[k] = o.values[i].v; return; }
          }
        });
      });
    }

    match(sel) {
      return this.cfg.variants.filter(function (v) {
        return sel.every(function (x, k) { return x === null || v.o[k] === x; });
      });
    }

    variantFor(sel) {
      if (sel.some(function (x) { return x === null; })) return null;
      return this.match(sel)[0] || null;
    }

    /* escolhe um valor e, se a combinacao nao existe/esta esgotada, troca as OUTRAS opcoes
       para a variante disponivel que mais combina com o que ja estava escolhido */
    choose(piece, k, value) {
      var sel = this.sel[piece].slice();
      sel[k] = value;
      var cands = this.cfg.variants.filter(function (v) { return v.a && v.o[k] === value; });
      if (cands.length) {
        var score = function (v) { return sel.reduce(function (n, x, m) { return n + (m !== k && x !== null && v.o[m] === x ? 1 : 0); }, 0); };
        var best = cands.slice().sort(function (a, b) { return score(b) - score(a); })[0];
        sel.forEach(function (x, m) { if (m !== k && x !== null && best.o[m] !== x) sel[m] = best.o[m]; });
      }
      this.sel[piece] = sel;
    }

    optionAvailable(piece, k, value) {
      var sel = this.sel[piece].slice();
      sel[k] = value;
      return this.match(sel).some(function (v) { return v.a; });
    }

    planTotals(n) {
      var total = 0, known = 0, self = this;
      for (var i = 0; i < n; i++) {
        var v = this.variantFor(this.sel[i]);
        if (v) { total += v.p; known++; }
      }
      /* pecas ainda sem tamanho: estima com o preco da primeira variante disponivel da cor */
      for (var j = 0; j < n; j++) {
        if (!this.variantFor(this.sel[j])) {
          var c = this.match(this.sel[j]).filter(function (v) { return v.a; })[0] || this.cfg.variants[0];
          total += c.p;
        }
      }
      var pct = this.pct[n];
      /* o checkout arredonda o desconto para BAIXO (verificado: 11598 x 15% = 1739,7 -> 1739) */
      var save = Math.floor(total * pct / 100);
      var disc = total - save;
      return { full: total, disc: disc, pct: pct, save: save, complete: known === n };
    }

    build() {
      var self = this, cfg = this.cfg, T = cfg.texts;
      var fs = h('fieldset', { class: 'td-bundle__plans' }, [h('legend', { class: 'visually-hidden', text: this.querySelector('.td-bundle__heading').textContent })]);
      this.cards = {};
      [1, 2, 3].forEach(function (n) {
        var id = 'tdb' + self.uid + '-plan' + n;
        var radio = h('input', { type: 'radio', class: 'td-bundle__radio', name: 'tdb' + self.uid + '-plan', id: id, value: String(n) });
        if (n === self.plan) radio.checked = true;
        radio.addEventListener('change', function () { self.plan = n; self.refresh(); });
        var title = h('span', { class: 'td-bundle__title' }, [
          h('span', { class: 'td-bundle__name', text: n === 1 ? T.single : n === 2 ? T.duo : T.trio })
        ]);
        if (self.pct[n] > 0) title.appendChild(h('span', { class: 'td-bundle__pct', text: T.save + ' ' + self.pct[n] + '%' }));
        var pop = (self.dataset.popular === 'trio' ? 3 : self.dataset.popular === 'single' ? 1 : 2) === n;
        if (pop && cfg.badge) title.appendChild(h('span', { class: 'td-bundle__badge', text: cfg.badge }));
        var price = h('span', { class: 'td-bundle__price' }, [
          h('s', { class: 'td-bundle__was', 'data-was': true }),
          h('strong', { class: 'td-bundle__now', 'data-now': true }),
          h('span', { class: 'td-bundle__sum', 'data-sum': true })
        ]);
        var label = h('label', { class: 'td-bundle__head', for: id }, [h('span', { class: 'td-bundle__dot', 'aria-hidden': 'true' }), title, price]);
        var pieces = h('div', { class: 'td-bundle__pieces' });
        for (var i = 0; i < n; i++) pieces.appendChild(self.buildPiece(n, i));
        var card = h('div', { class: 'td-bundle__card' }, [radio, label, pieces]);
        self.cards[n] = card;
        fs.appendChild(card);
      });
      this.mount.appendChild(fs);
    }

    buildPiece(n, i) {
      var self = this, cfg = this.cfg, T = cfg.texts;
      var wrap = h('div', { class: 'td-bundle__piece' });
      if (!this.single) {
        wrap.appendChild(h('p', { class: 'td-bundle__piece-title', text: (n > 1 ? T.piece + ' #' + (i + 1) : '') }));
        cfg.options.forEach(function (o, k) {
          if (o.values.length === 1) return;
          var gid = 'tdb' + self.uid + '-' + n + '-' + i + '-' + k;
          var group = h('div', { class: 'td-bundle__group', role: 'radiogroup', 'aria-labelledby': gid + '-l' });
          var lab = h('span', { class: 'td-bundle__opt-label', id: gid + '-l', text: o.name });
          var row = h('div', { class: 'td-bundle__chips' });
          o.values.forEach(function (val, vi) {
            var cid = gid + '-' + vi;
            var inp = h('input', { type: 'radio', class: 'td-bundle__chip-input', name: gid, id: cid, value: val.v });
            inp.dataset.piece = i; inp.dataset.opt = k; inp.dataset.val = val.v;
            inp.addEventListener('change', function () {
              self.choose(i, k, val.v);
              self.msg.textContent = '';
              self.refresh();
            });
            var kids = [];
            if (val.swatch) {
              var sw = h('span', { class: 'td-bundle__swatch', 'aria-hidden': 'true' });
              sw.style.background = val.swatch;
              kids.push(sw);
            }
            kids.push(h('span', { text: val.v }));
            row.appendChild(inp);
            row.appendChild(h('label', { class: 'td-bundle__chip', for: cid }, kids));
          });
          group.appendChild(lab);
          group.appendChild(row);
          wrap.appendChild(group);
        });
      } else if (n > 1) {
        wrap.appendChild(h('p', { class: 'td-bundle__piece-title', text: T.piece + ' #' + (i + 1) }));
      }
      return wrap;
    }

    refresh() {
      var self = this, T = this.cfg.texts;
      [1, 2, 3].forEach(function (n) {
        var card = self.cards[n], on = n === self.plan;
        card.classList.toggle('is-selected', on);
        card.querySelector('.td-bundle__radio').checked = on;
        var t = self.planTotals(n);
        var was = card.querySelector('[data-was]'), now = card.querySelector('[data-now]');
        /* destaque = preco de CADA peca ja com o desconto do bundle; embaixo, n x preco = total */
        var each = Math.round(t.disc / n), exact = each * n === t.disc;
        now.textContent = (exact ? '' : '\u2248 ') + shortMoney(self.fmt(each));
        if (t.pct > 0) { was.textContent = shortMoney(self.fmt(Math.round(t.full / n))); was.hidden = false; } else { was.hidden = true; was.textContent = ''; }
        var sum = card.querySelector('[data-sum]');
        if (n > 1) { sum.textContent = n + ' \u00d7 ' + shortMoney(self.fmt(each)) + ' = ' + shortMoney(self.fmt(t.disc)); sum.hidden = false; } else { sum.textContent = ''; sum.hidden = true; }
      });
      /* chips: estado marcado + esgotado */
      this.querySelectorAll('.td-bundle__chip-input').forEach(function (inp) {
        var p = Number(inp.dataset.piece), k = Number(inp.dataset.opt);
        inp.checked = self.sel[p][k] === inp.dataset.val;
        var ok = self.cfg.variants.some(function (v) { return v.a && v.o[k] === inp.dataset.val; });
        inp.disabled = !ok;
        var lab = inp.nextElementSibling;
        lab.classList.toggle('is-soldout', !ok);
        if (!ok) lab.setAttribute('title', T.soldOut); else lab.removeAttribute('title');
      });
      var tt = this.planTotals(this.plan);
      var lbl = this.atc.querySelector('[data-atc-label]');
      lbl.textContent = this.cfg.button + ' — ' + this.fmt(tt.disc);
      this.atc.toggleAttribute('data-incomplete', !tt.complete);
      this.atc.setAttribute('aria-disabled', tt.complete ? 'false' : 'true');
    }

    add() {
      var self = this, T = this.cfg.texts;
      if (this.busy) return;
      var n = this.plan, items = {}, order = [];
      for (var i = 0; i < n; i++) {
        var v = this.variantFor(this.sel[i]);
        if (!v || !v.a) { this.msg.textContent = T.selectFirst; this.msg.classList.add('is-error'); return; }
        if (!items[v.id]) { items[v.id] = 0; order.push(v.id); }
        items[v.id]++;
      }
      this.msg.classList.remove('is-error');
      this.msg.textContent = '';
      this.busy = true;
      this.atc.classList.add('loading');
      this.atc.setAttribute('aria-disabled', 'true');
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var body = { items: order.map(function (id) { return { id: id, quantity: items[id] }; }) };
      if (cart && cart.getSectionsToRender) {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; }).join(',');
        body.sections_url = window.location.pathname;
        if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
      }
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok || res.d.status) {
            self.msg.classList.add('is-error');
            self.msg.textContent = res.d.description || res.d.message || T.error;
            return;
          }
          if (!cart) { window.location = (window.routes && window.routes.cart_url) || '/cart'; return; }
          try {
            if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'td-bundle', productVariantId: order[0], cartData: res.d });
            }
          } catch (e) {}
          cart.renderContents(res.d);
        })
        .catch(function () { self.msg.classList.add('is-error'); self.msg.textContent = T.error; })
        .finally(function () {
          self.busy = false;
          /* igual ao product-form do tema: sem isso a gaveta aberta de carrinho vazio quebra o trapFocus */
          if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          self.atc.classList.remove('loading');
          self.refresh();
        });
    }
  });
})();
